import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface UpdateRfqMarkdownPayload {
  rfq_id: number;
  rfq_markdown: string;
}

export interface UpdateRfqMarkdownResponse {
  rfq: {
    id: number;
    rfq_markdown: string;
    document: {
      name: string;
      rfq_markdown?: string;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
}

/**
 * Updates the rfq_markdown field for an RFQ.
 * This endpoint also filters prices and updates associated products.
 */
export const updateRfqMarkdown = async (
  payload: UpdateRfqMarkdownPayload
): Promise<UpdateRfqMarkdownResponse> => {
  try {
    const { data } = await apiService.patch(`/rfqs/${payload.rfq_id}`, {
      document: {
        rfq_markdown: payload.rfq_markdown
      }
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
